// AMS-100: whether Gang Leaders can be allocated to a booking. A payment replaces
// lastStatus with PAYMENT, so "confirmed" is read from the status history.
// Same rule as glAllocationBlockedReason in the API (farmerBookingBatch.service.js): keep in sync.
export function canAllocateGangLeaders(booking) {
  if (!booking) return false;
  if (booking.lastStatus === "CANCELLED" || booking.bookingStatus === "CANCELLED") return false;
  if (booking.lastStatus === "BOOKINGCOMPLETED" || booking.bookingStatus === "COMPLETED") return false;
  const confirmed =
    booking.lastStatus === "BOOKINGCONFIRMED" ||
    (booking.bookingStatusHistory || []).some((h) => h.bookingTracking === "BOOKINGCONFIRMED");
  if (!confirmed) return false;
  return !["PENDING_FARMER", "PENDING_ADMIN"].includes(booking.currentDimensionChangeStatus);
}
